<template>
  <v-container class="container-card">
    <v-card>
      <TabelaDepartamento />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaDepartamento",

  components: {
    TabelaDepartamento: () =>
      import("@/components/empresa/departamento/TabelaDepartamento")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Departamento");
  }
};
</script>
